import { FC, 
    useState
 } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { CourseEvent } from '../../../models/CourseEvent';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import { Trash } from 'react-bootstrap-icons';
import SurveyResponseEndpoint from '../../../../api/endpoint/SurveyResponseEndpoint';

interface BulkSurveyProps {
    courseEvent: CourseEvent;
    show: boolean;
    onHide: () => void;
}

export const BulkSurvey: FC<BulkSurveyProps> = ({courseEvent, show, onHide}) => {
    const [q1StronglyAgree, setQ1StronglyAgree] = useState(0);
    const [q1Agree, setQ1Agree] = useState(0);
    const [q1Disagree, setQ1Disagree] = useState(0);
    const [q1StronglyDisagree, setQ1StronglyDisagree] = useState(0);

    const [q2StronglyAgree, setQ2StronglyAgree] = useState(0);
    const [q2Agree, setQ2Agree] = useState(0);
    const [q2Disagree, setQ2Disagree] = useState(0);
    const [q2StronglyDisagree, setQ2StronglyDisagree] = useState(0);

    const [q3StronglyAgree, setQ3StronglyAgree] = useState(0);
    const [q3Agree, setQ3Agree] = useState(0);
    const [q3Disagree, setQ3Disagree] = useState(0);
    const [q3StronglyDisagree, setQ3StronglyDisagree] = useState(0);

    const [q4StronglyAgree, setQ4StronglyAgree] = useState(0);
    const [q4Agree, setQ4Agree] = useState(0);
    const [q4Disagree, setQ4Disagree] = useState(0);
    const [q4StronglyDisagree, setQ4StronglyDisagree] = useState(0);

    const [q5StronglyAgree, setQ5StronglyAgree] = useState(0);
    const [q5Agree, setQ5Agree] = useState(0);
    const [q5Disagree, setQ5Disagree] = useState(0);
    const [q5StronglyDisagree, setQ5StronglyDisagree] = useState(0);

    const [q6StronglyAgree, setQ6StronglyAgree] = useState(0);
    const [q6Agree, setQ6Agree] = useState(0);
    const [q6Disagree, setQ6Disagree] = useState(0);
    const [q6StronglyDisagree, setQ6StronglyDisagree] = useState(0);

    const [q7StronglyAgree, setQ7StronglyAgree] = useState(0);
    const [q7Agree, setQ7Agree] = useState(0);
    const [q7Disagree, setQ7Disagree] = useState(0);
    const [q7StronglyDisagree, setQ7StronglyDisagree] = useState(0);

    const [q8StronglyAgree, setQ8StronglyAgree] = useState(0);
    const [q8Agree, setQ8Agree] = useState(0);
    const [q8Disagree, setQ8Disagree] = useState(0);
    const [q8StronglyDisagree, setQ8StronglyDisagree] = useState(0);

    const [shortResponse1, setShortResponse1] = useState<string[]>(['']);
    const [shortResponse2, setShortResponse2] = useState<string[]>(['']);
    const [shortResponse3, setShortResponse3] = useState<string[]>(['']);
    const [shortResponse4, setShortResponse4] = useState<string[]>(['']);
    const [shortResponse5, setShortResponse5] = useState<string[]>(['']);

    const [validated, setValidated] = useState(false);

    const handleSubmit = async (event: any) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        else if(form.checkValidity() === true) {
            event.preventDefault();
            await SurveyResponseEndpoint.SubmitBulk({
                course_event_id: courseEvent.course_event_id,
                q1StronglyAgree: q1StronglyAgree,
                q1Agree: q1Agree,
                q1Disagree: q1Disagree,
                q1StronglyDisagree: q1StronglyDisagree,

                q2StronglyAgree: q2StronglyAgree,
                q2Agree: q2Agree,
                q2Disagree: q2Disagree,
                q2StronglyDisagree: q2StronglyDisagree,

                q3StronglyAgree: q3StronglyAgree,
                q3Agree: q3Agree,
                q3Disagree: q3Disagree,
                q3StronglyDisagree: q3StronglyDisagree,

                q4StronglyAgree: q4StronglyAgree,
                q4Agree: q4Agree,
                q4Disagree: q4Disagree,
                q4StronglyDisagree: q4StronglyDisagree,

                q5StronglyAgree: q5StronglyAgree,
                q5Agree: q5Agree,
                q5Disagree: q5Disagree,
                q5StronglyDisagree: q5StronglyDisagree,

                q6StronglyAgree: q6StronglyAgree,
                q6Agree: q6Agree,
                q6Disagree: q6Disagree,
                q6StronglyDisagree: q6StronglyDisagree,

                q7StronglyAgree: q7StronglyAgree,
                q7Agree: q7Agree,
                q7Disagree: q7Disagree,
                q7StronglyDisagree: q7StronglyDisagree,

                q8StronglyAgree: q8StronglyAgree,
                q8Agree: q8Agree,
                q8Disagree: q8Disagree,
                q8StronglyDisagree: q8StronglyDisagree,

                shortResponse1: shortResponse1,
                shortResponse2: shortResponse2,
                shortResponse3: shortResponse3,
                shortResponse4: shortResponse4,
                shortResponse5: shortResponse5
            })
            onHide();
        }

        setValidated(true);
    };
    return (
        <Modal
            show={show}
            size="xl"
            aria-labelledby="course-title"
            centered
            onHide={onHide}
            backdrop="static"
            style={{height: '100vh', overflowY: 'scroll'}}
        >
            <Modal.Header closeButton>
                <Modal.Title id="course-title">Bulk Survey Responses Entry</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Table responsive className="w-auto">
                    <thead>
                        <tr className='text-center'>
                            <td className="w-auto"></td>
                            <th style={{width:'10em'}}>Strongly Agree</th>
                            <th style={{width:'10em'}}>Agree</th>
                            <th style={{width:'10em'}}>Disagree</th>
                            <th style={{width:'10em'}}>Strongly Disagree</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th><span>The class session was well-organized</span></th>
                            <td className="text-center">
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q1StronglyAgree}
                                    onChange={(e:any) => setQ1StronglyAgree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 1 Strongly Agree"
                                />
                            </td>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q1Agree}
                                    onChange={(e:any) => setQ1Agree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 1 Agree"
                                />
                            </td>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q1Disagree}
                                    onChange={(e:any) => setQ1Disagree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 1 Disagree"
                                />
                            </td>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q1StronglyDisagree}
                                    onChange={(e:any) => setQ1StronglyDisagree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 1 Strongly Disagree"
                                />
                            </td>
                        </tr>
                        <tr>
                            <th><span>The instructor presented the subject matter clearly</span></th>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q2StronglyAgree}
                                    onChange={(e:any) => setQ2StronglyAgree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 2 Strongly Agree"
                                />
                            </td>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q2Agree}
                                    onChange={(e:any) => setQ2Agree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 2 Agree"
                                />
                            </td>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q2Disagree}
                                    onChange={(e:any) => setQ2Disagree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 2 Disagree"
                                />
                            </td>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q2StronglyDisagree}
                                    onChange={(e:any) => setQ2StronglyDisagree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 2 Strongly Disagree"
                                />
                            </td>
                        </tr>
                        <tr>
                            <th><span>The class content was pertinent to my job</span></th>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q3StronglyAgree}
                                    onChange={(e:any) => setQ3StronglyAgree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 3 Strongly Agree"
                                />
                            </td>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q3Agree}
                                    onChange={(e:any) => setQ3Agree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 3 Agree"
                                />
                            </td>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q3Disagree}
                                    onChange={(e:any) => setQ3Disagree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 3 Disagree"
                                />
                            </td>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q3StronglyDisagree}
                                    onChange={(e:any) => setQ3StronglyDisagree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 3 Strongly Disagree"
                                />
                            </td>
                        </tr>
                        <tr>
                            <th><span>The presentation was clear and understandable</span></th>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q4StronglyAgree}
                                    onChange={(e:any) => setQ4StronglyAgree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 4 Strongly Agree"
                                />
                            </td>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q4Agree}
                                    onChange={(e:any) => setQ4Agree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 4 Agree"
                                />
                            </td>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q4Disagree}
                                    onChange={(e:any) => setQ4Disagree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 4 Disagree"
                                />
                            </td>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q4StronglyDisagree}
                                    onChange={(e:any) => setQ4StronglyDisagree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 4 Strongly Disagree"
                                />
                            </td>
                        </tr>
                        <tr>
                            <th><span>The instructor was well-prepared</span></th>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q5StronglyAgree}
                                    onChange={(e:any) => setQ5StronglyAgree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 5 Strongly Agree"
                                />
                            </td>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q5Agree}
                                    onChange={(e:any) => setQ5Agree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 5 Agree"
                                />
                            </td>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q5Disagree}
                                    onChange={(e:any) => setQ5Disagree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 5 Disagree"
                                />
                            </td>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q5StronglyDisagree}
                                    onChange={(e:any) => setQ5StronglyDisagree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 5 Strongly Disagree"
                                />
                            </td>
                        </tr>
                        <tr>
                            <th><span>The instructor encouraged questions</span></th>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q6StronglyAgree}
                                    onChange={(e:any) => setQ6StronglyAgree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 6 Strongly Agree"
                                />
                            </td>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q6Agree}
                                    onChange={(e:any) => setQ6Agree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 6 Agree"
                                />
                            </td>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q6Disagree}
                                    onChange={(e:any) => setQ6Disagree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 6 Disagree"
                                />
                            </td>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q6StronglyDisagree}
                                    onChange={(e:any) => setQ6StronglyDisagree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 6 Strongly Disagree"
                                />
                            </td>
                        </tr>
                        <tr>
                            <th><span>The course materials were useful</span></th>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q7StronglyAgree}
                                    onChange={(e:any) => setQ7StronglyAgree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 7 Strongly Agree"
                                />
                            </td>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q7Agree}
                                    onChange={(e:any) => setQ7Agree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 7 Agree"
                                />
                            </td>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q7Disagree}
                                    onChange={(e:any) => setQ7Disagree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 7 Disagree"
                                />
                            </td>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q7StronglyDisagree}
                                    onChange={(e:any) => setQ7StronglyDisagree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 7 Strongly Disagree"
                                />
                            </td>
                        </tr>
                        <tr>
                            <th><span>The class examples helped clarify the instruction</span></th>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q8StronglyAgree}
                                    onChange={(e:any) => setQ8StronglyAgree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 8 Strongly Agree"
                                />
                            </td>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q8Agree}
                                    onChange={(e:any) => setQ8Agree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 8 Agree"
                                />
                            </td>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q8Disagree}
                                    onChange={(e:any) => setQ8Disagree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 8 Disagree"
                                />
                            </td>
                            <td className='text-center'>
                                <Form.Control
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={q8StronglyDisagree}
                                    onChange={(e:any) => setQ8StronglyDisagree(Number(e.target.value))}
                                    style={{width:'5em', display:'inline-block'}}
                                    aria-label="Question 8 Strongly Disagree"
                                />
                            </td>
                        </tr>
                    </tbody>
                </Table>
                <Form.Group className="mb-4" controlId="q9">
                    <div className="d-flex justify-content-between mb-2">
                        <Form.Label>What did you like most about this training?</Form.Label>
                        <Button variant='primary' className='text-light' 
                            onClick={(_e: any) => {
                                const copy = structuredClone(shortResponse1);
                                copy.push('');
                                setShortResponse1(copy);
                            }}
                        >
                            Add Response
                        </Button>
                    </div>  
                    {shortResponse1.map((response: string, i: number) => (
                        <div className="d-flex mb-3 gap-3" key={`response1_${i}`}>
                            <Form.Control  
                                as="textarea" 
                                rows={2}
                                value={response}
                                onChange={(e: any) => {
                                    const copy = structuredClone(shortResponse1);
                                    copy[i] = e.target.value;
                                    setShortResponse1(copy);
                                }}
                            />
                            <div className="d-flex justify-content-center align-items-center">
                                <Button 
                                    className="text-light" 
                                    variant="danger"
                                    onClick={() => {
                                        const copy = structuredClone(shortResponse1);
                                        copy.splice(i, 1);
                                        setShortResponse1(copy);
                                    }}
                                    aria-label="Delete Response"
                                >
                                    <Trash/>
                                </Button>
                            </div>
                        </div>
                    ))}
                    
                </Form.Group>
                <Form.Group className="mb-4" controlId="q10">
                    <div className="d-flex justify-content-between mb-2">
                        <Form.Label>What did you like least about this training?</Form.Label>
                        <Button variant='primary' className='text-light' 
                            onClick={(_e: any) => {
                                const copy = structuredClone(shortResponse2);
                                copy.push('');
                                setShortResponse2(copy);
                            }}
                        >
                            Add Response
                        </Button>
                    </div>  
                    {shortResponse2.map((response: string, i: number) => (
                        <div className="d-flex mb-3 gap-3" key={`response2_${i}`}>
                            <Form.Control  
                                as="textarea" 
                                rows={2}
                                value={response}
                                onChange={(e: any) => {
                                    const copy = structuredClone(shortResponse2);
                                    copy[i] = e.target.value;
                                    setShortResponse2(copy);
                                }}
                            />
                            <div className="d-flex justify-content-center align-items-center">
                                <Button 
                                    className="text-light" 
                                    variant="danger"
                                    onClick={() => {
                                        const copy = structuredClone(shortResponse2);
                                        copy.splice(i, 1);
                                        setShortResponse2(copy);
                                    }}
                                    aria-label="Delete Response"
                                >
                                    <Trash/>
                                </Button>
                            </div>
                        </div>
                    ))}
                </Form.Group>

                <Form.Group className="mb-4" controlId="q11">
                    <div className="d-flex justify-content-between mb-2">
                        <Form.Label>What, if anything, would you add, delete, or change about this class?</Form.Label>
                        <Button variant='primary' className='text-light' 
                            onClick={(_e: any) => {
                                const copy = structuredClone(shortResponse3);
                                copy.push('');
                                setShortResponse3(copy);
                            }}
                        >
                            Add Response
                        </Button>
                    </div>  
                    {shortResponse3.map((response: string, i: number) => (
                        <div className="d-flex mb-3 gap-3" key={`Response3_${i}`}>
                            <Form.Control  
                                as="textarea" 
                                rows={2}
                                value={response}
                                onChange={(e: any) => {
                                    const copy = structuredClone(shortResponse3);
                                    copy[i] = e.target.value;
                                    setShortResponse3(copy);
                                }}
                            />
                            <div className="d-flex justify-content-center align-items-center">
                                <Button 
                                    className="text-light" 
                                    variant="danger"
                                    onClick={() => {
                                        const copy = structuredClone(shortResponse3);
                                        copy.splice(i, 1);
                                        setShortResponse3(copy);
                                    }}
                                    aria-label="Delete Response"
                                >
                                    <Trash/>
                                </Button>
                            </div>
                        </div>
                    ))}
                </Form.Group>

                <Form.Group className="mb-4" controlId="q12">
                    <div className="d-flex justify-content-between mb-2">
                        <Form.Label>Do you have specific suggestions for improvement? If so, please elaborate.</Form.Label>
                        <Button variant='primary' className='text-light' 
                            onClick={(_e: any) => {
                                const copy = structuredClone(shortResponse4);
                                copy.push('');
                                setShortResponse4(copy);
                            }}
                        >
                            Add Response
                        </Button>
                    </div>  
                    {shortResponse4.map((response: string, i: number) => (
                        <div className="d-flex mb-3 gap-3" key={`Response4_${i}`}>
                            <Form.Control  
                                as="textarea" 
                                rows={2}
                                value={response}
                                onChange={(e: any) => {
                                    const copy = structuredClone(shortResponse4);
                                    copy[i] = e.target.value;
                                    setShortResponse4(copy);
                                }}
                            />
                            <div className="d-flex justify-content-center align-items-center">
                                <Button 
                                    className="text-light" 
                                    variant="danger"
                                    onClick={() => {
                                        const copy = structuredClone(shortResponse4);
                                        copy.splice(i, 1);
                                        setShortResponse4(copy);
                                    }}
                                    aria-label="Delete Response"
                                >
                                    <Trash/>
                                </Button>
                            </div>
                        </div>
                    ))}
                </Form.Group>

                <Form.Group className="mb-4" controlId="q13">
                    <div className="d-flex justify-content-between mb-2">
                        <Form.Label>Other Comments</Form.Label>
                        <Button variant='primary' className='text-light' 
                            onClick={(_e: any) => {
                                const copy = structuredClone(shortResponse5);
                                copy.push('');
                                setShortResponse5(copy);
                            }}
                        >
                            Add Response
                        </Button>
                    </div>  
                    {shortResponse5.map((response: string, i: number) => (
                        <div className="d-flex mb-3 gap-3" key={`Response5_${i}`}>
                            <Form.Control  
                                as="textarea" 
                                rows={2}
                                value={response}
                                onChange={(e: any) => {
                                    const copy = structuredClone(shortResponse5);
                                    copy[i] = e.target.value;
                                    setShortResponse5(copy);
                                }}
                            />
                            <div className="d-flex justify-content-center align-items-center">
                                <Button 
                                    className="text-light" 
                                    variant="danger"
                                    onClick={() => {
                                        const copy = structuredClone(shortResponse5);
                                        copy.splice(i, 1);
                                        setShortResponse5(copy);
                                    }}
                                    aria-label="Delete Response"
                                >
                                    <Trash/>
                                </Button>
                            </div>
                        </div>
                    ))}
                </Form.Group>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide}>Close</Button>
                    <Button variant="primary" className="text-light" type="submit">Submit</Button>
                </Modal.Footer>
                </Form>
            </Modal.Body>
        </Modal>
    )
}